import { render, staticRenderFns } from "./shopQrCodeHouse.vue?vue&type=template&id=7bfc0848&scoped=true"
import script from "./shopQrCodeHouse.vue?vue&type=script&lang=js"
export * from "./shopQrCodeHouse.vue?vue&type=script&lang=js"
import style0 from "./shopQrCodeHouse.vue?vue&type=style&index=0&id=7bfc0848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfc0848",
  null
  
)

export default component.exports